import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { faWifi } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SmallModalTemplate from 'src/components/SmallModalTemplate';

import { I18NextNS } from 'src/models/Language.model';

type ConnectionRestoredModalProps = {
  show: boolean;
  dataTest: string;
  onClose: () => void;
};
export default function ConnectionRestoredModal({
  show,
  dataTest,
  onClose,
}: ConnectionRestoredModalProps) {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'connectionIssue.connectionRestoredModal',
  });

  return (
    <SmallModalTemplate
      show={show}
      data-test={dataTest}
      icon={<FontAwesomeIcon icon={faWifi} className="text-success" />}
      iconWrapperClassName="bg-success-100"
      title={t('title')}
      description={t('description')}
      rightButton={
        <Button
          variant="outline-gray-500"
          className="clear-exam-button"
          data-test="connection-restored-close-button"
          onClick={onClose}
        >
          {t('close')}
        </Button>
      }
    />
  );
}
